var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJointhecommunityX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0872277 0L14.0893 18.7527L0 34H3.17185L15.5082 20.6515L25.4747 34H36.2667L21.4775 14.1924L34.5925 0H31.4206L20.0607 12.2937L10.8813 0H0.0893311H0.0872277ZM4.75031 2.33983H9.707L31.5993 31.6602H26.6426L4.75031 2.33983Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJointhecommunityX);
export default __webpack_public_path__ + "static/media/jointhecommunity-x.3f056868e5b7536b7b9b39efa0e110d4.svg";
export { ForwardRef as ReactComponent };